import fetch from 'utils/fetch'
/*SAMPLES API*/

// general
export function getCvAllSourceType () {
  return fetch({
    url: '/project/sample/getCvAllSourceType',
    method: 'post'
  })
}
export function getCvRoot (data) {
  return fetch({
    url: '/project/sample/getCvRoot',
    method: 'post',
    data
  })
}

export function getCvSpecies (data) {
  return fetch({
    url: '/project/sample/getCvSpecies',
    method: 'post',
    data
  })
}

export function getCvGender () {
  return fetch({
    url: '/project/sample/getCvGender',
    method: 'post'
  })
}

export function getCvSamUnit (data) {
  return fetch({
    url: '/project/sample/getCvUnit',
    method: 'post',
    data
  })
}
export function getCvSourceType (data) {
  return fetch({
    url: '/project/sample/getCvSourceType',
    method: 'post',
    data
  })
}

export function getCvStrain (data) {
  return fetch({
    url: '/project/sample/getCvStrain',
    method: 'post',
    data
  })
}

export function getCvGenotype () {
  return fetch({
    url: '/project/sample/getCvGenotype',
    method: 'post'
  })
}

// type
export function getCvSystemName (data) {
  return fetch({
    url: '/project/sample/getCvSystemName',
    method: 'post',
    data
  })
}
export function getCvOrganName (data) {
  return fetch({
    url: '/project/sample/getCvOrganName',
    method: 'post',
    data
  })
}
export function getCvComplexOrgan (data) {
  return fetch({
    url: '/project/sample/getCvComplexOrgan',
    method: 'post',
    data
  })
}
export function getCvOrganAndSystem (data) {
  return fetch({
    url: '/project/sample/getCvOrganAndSystem',
    method: 'post',
    data
  })
}
export function getCvTissueName (data) {
  return fetch({
    url: '/project/sample/getCvTissueName',
    method: 'post',
    data
  })
}
export function getCvTissueStatus () {
  return fetch({
    url: '/project/sample/getCvTissueStatus',
    method: 'post'
  })
}
export function getCvCellName (data) {
  return fetch({
    url: '/project/sample/getCvCellName',
    method: 'post',
    data
  })
}
export function getCvCellType () {
  return fetch({
    url: '/project/sample/getCvCellType',
    method: 'post'
  })
}
export function getCvMicroorganismName (data) {
  return fetch({
    url: '/project/sample/getCvMicroorganismName',
    method: 'post',
    data
  })
}
export function getCvMicroorganismType () {
  return fetch({
    url: '/project/sample/getCvMicroorganismType',
    method: 'post'
  })
}
export function getCvOrganelle (data) {
  return fetch({
    url: '/project/sample/getCvOrganelle',
    method: 'post',
    data
  })
}
export function getCvFluid (data) {
  return fetch({
    url: '/project/sample/getCvFluid',
    method: 'post',
    data
  })
}
// storage
export function getCvLocationTemperature (data) {
  return fetch({
    url: '/project/sample/getCvLocationTemperature',
    method: 'post',
    data
  })
}
export function getCvLocationType () {
  return fetch({
    url: '/project/sample/getCvLocationType',
    method: 'post'
  })
}
// treatment

export function getCvTreatmentMethod (data) {
  return fetch({
    url: '/project/sample/getCvTreatmentMethod',
    method: 'post',
    data
  })
}
export function getCvTreatmentType () {
  return fetch({
    url: '/project/sample/getCvTreatmentType',
    method: 'post'
  })
}
export function getCvUnit (data) {
  return fetch({
    url: '/project/sample/getCvUnit',
    method: 'post',
    data
  })
}
export function getCvUnitType () {
  return fetch({
    url: '/project/sample/getCvUnitType',
    method: 'post'
  })
}
export function getCvUnitAll (data) {
  return fetch({
    url: '/project/sample/getCvUnitAll',
    method: 'post',
    data
  })
}
export function getCvAllStrain (data) {
  return fetch({
    url: '/project/sample/getCvAllStrain',
    method: 'post',
    data
  })
}

// submit api
export function getSubmist (data) {
  return fetch({
    url: '/project/sample/createSample',
    method: 'post',
    data
  })
}

export function getSampleTableList (data) {
  return fetch({
    url: '/project/sample/getSampleList',
    method: 'post',
    data
  })
}

export function getSampleListData (data) {
  return fetch({
    url: '/project/sample/getSampleListData',
    method: 'post',
    data
  })
}
export function getSampleListCount (data) {
  return fetch({
    url: '/project/sample/getSampleListCount',
    method: 'post',
    data
  })
}
// search & filter
export function getDistinctDescription (data) {
  return fetch({
    url: '/project/sample/getDistinctDescription',
    method: 'post',
    data
  })
}
export function getDistinctOperator (data) {
  return fetch({
    url: '/project/sample/getDistinctOperator',
    method: 'post',
    data
  })
}
export function getDistinctSourceType (data) {
  return fetch({
    url: '/project/sample/getDistinctSourceType',
    method: 'post',
    data
  })
}
export function getDistinctTreatmentA (data) {
  return fetch({
    url: '/project/sample/getDistinctTreatmentA',
    method: 'post',
    data
  })
}
export function getDistinctTreatmentB (data) {
  return fetch({
    url: '/project/sample/getDistinctTreatmentB',
    method: 'post',
    data
  })
}
export function getSampleView (data) {
  return fetch({
    url: '/project/sample/getSampleView',
    method: 'post',
    data
  })
}
// show sample
export function getSampleListAndStickAnEntry (data) {
  return fetch({
    url: '/project/sample/getSampleListAndStickAnEntry',
    method: 'post',
    data
  })
}
// draft sample
export function getSampleListInProvidedIds (data) {
  return fetch({
    url: '/project/sample/getSampleListInProvidedIds',
    method: 'post',
    data
  })
}
export function getSampleListNotInProvidedIds (data) {
  return fetch({
    url: '/project/sample/getSampleListNotInProvidedIdsData',
    method: 'post',
    data
  })
}
export function getSampleListNotInProvidedIdCount (data) {
  return fetch({
    url: '/project/sample/getSampleListNotInProvidedIdCount',
    method: 'post',
    data
  })
}
// modify sample
export function modifySample (data) {
  return fetch({
    url: '/project/sample/modifySample',
    method: 'post',
    data
  })
}

export function deleteSample (data) {
  return fetch({
    url: '/project/sample/deleteSample',
    method: 'post',
    data
  })
}
// multiple sampls
export function getSampleTemplate (data) {
  return fetch({
    url: '/project/sample/getSampleTemplate',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/samples.js